import React from 'react';
import { motion } from 'framer-motion';

const features = [
  {
    title: 'Global Payment Access',
    icon: (
      <span role="img" aria-label="globe" className="text-3xl">🌍</span>
    ),
    description: 'Effortlessly connect to multiple payment networks and expand your reach worldwide.'
  },
  {
    title: 'Intelligent Transaction Routing',
    icon: (
      <span role="img" aria-label="robot" className="text-3xl">🤖</span>
    ),
    description: 'AI-powered routing to maximize approvals and minimize declines, tailored to your business.'
  },
  {
    title: 'Flexible Integration',
    icon: (
      <span role="img" aria-label="link" className="text-3xl">🔗</span>
    ),
    description: 'Plug-and-play APIs and hosted solutions for rapid deployment and customization.'
  },
  {
    title: 'Unified Settlement',
    icon: (
      <span role="img" aria-label="clipboard" className="text-3xl">📋</span>
    ),
    description: 'Consolidate all your payment data and settlements in one clear, actionable report.'
  },
  {
    title: 'Live Insights',
    icon: (
      <span role="img" aria-label="chart" className="text-3xl">📊</span>
    ),
    description: 'Monitor transactions in real time and make data-driven decisions with instant analytics.'
  },
  {
    title: 'Centralized Control Panel',
    icon: (
      <span role="img" aria-label="dashboard" className="text-3xl">🖥️</span>
    ),
    description: 'Manage all your payment operations from a single, intuitive dashboard.'
  },
];

const FeaturesGrid: React.FC = () => (
  <section className="py-20 bg-white">
    <div className="container mx-auto px-4">
      <div className="text-center mb-14">
        <h2 className="text-3xl md:text-4xl font-extrabold mb-4 text-black">Unlock Seamless Payments & Optimize Your Business</h2>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
          Discover how PayXB empowers you with advanced tools for global payments, analytics, and operational efficiency.
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {features.map((feature, idx) => (
          <motion.div
            key={feature.title}
            className={
              'rounded-2xl p-8 bg-white shadow-3d transition-transform duration-300 hover:-translate-y-2 hover:shadow-card-hover border border-black/5'
            }
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: idx * 0.1 }}
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.98 }}
          >
            <div className="mb-6 flex items-center justify-center text-black">{feature.icon}</div>
            <h3 className="text-xl font-bold mb-2 text-black">{feature.title}</h3>
            <p className="text-gray-700 text-base leading-relaxed">{feature.description}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default FeaturesGrid; 